// Where the CMS lives on the site. Not linked from anywhere public; access is
// still protected by login + 2FA, the unusual path just keeps bots away.
export const CMS_BASE = "/ptx-desk";

export function cmsPath(path = "/") {
  return path === "/" ? CMS_BASE : `${CMS_BASE}${path}`;
}

export const TOKEN_KEY = "cms_token";
